import { useSuspenseQuery } from '@tanstack/react-query';

import { useMetaApiInstance } from '../api';
import { HOST_QUERY_KEY } from '../constants';
import useServiceAppState from './useServiceAppState';

import type { MegaMenuCategory } from '../constants';

/**
 * 리전에 따라서 콘솔 전체 메뉴 데이터를 제공하는 훅입니다.
 * @description
 * - Meta Api의 응답값을 react-query로 제공합니다.
 * - SSR을 지원하고 있습니다.
 * - queryKey를 기반으로 revalidate 할 수 있습니다.
 */
const useMegaMenuQuery = () => {
  const {
    state: { region, language },
  } = useServiceAppState();
  const { fetchMegaMenu } = useMetaApiInstance();

  return useSuspenseQuery<MegaMenuCategory[]>({
    queryKey: [HOST_QUERY_KEY.GET_MEGA_MENU, region ? { language, region } : { language }],
    queryFn: () => fetchMegaMenu({ region }),
    staleTime: Infinity,
  });
};

export default useMegaMenuQuery;
